import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class NotificationService {
    async fetch(page = 1, pageSize = 10, is_read = "") {
        // if is_read is passed (like 0 or 1), include it in the URL
        const url = is_read !== ""
            ? `/notifications?page=${page}&is_read=${is_read}`
            : `/notifications?page=${page}`;

        const response = await ajaxService.get(url);

        if (response?.success ?? false) {
            return response;
        }
    }


    async add(data) {
        const response = await ajaxService.post(`/notifications`, data)
        if (response?.success ?? false) {
            return response;
        } else {
            const errors = response.data.errors;
            return validationErrors(errors)
        }
    }
    async read(id) {
        const response = await ajaxService.post(`/notifications/${id}/mark-read`)
        // if (response?.success ?? false) {
        //     return response;
        // } else {
        //     const errors = response.data.errors;
        //     return validationErrors(errors)
        // }
        return response;
    }
}

const notificationService = new NotificationService();

export default notificationService